<!-- 公共头部菜单 -->
<template>
  <div class="headerWrap">
    <div class="header w100" :class="{ headerScr: isScroll }">
      <div class="age"><img :src="ageImg" alt=""></div>
      <div class="navWrap">
        <span class="navLi" :class="{ active: index == navActive }" v-for="(item, index) in navList" :key="index"
          @click="navFn(item, index)">
          <img v-if="item.name == 'logo'" src="@/assets/imgs/head/headLogo.png" alt="">
          <span v-else>{{ item.name }}</span>
        </span>

      </div>
    </div>
  </div>
</template>

<script>
import { publicUrl } from '@/common/publicUrl.js'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      isScroll: false,
      navActive: 0,
      ageImg: require('@/assets/imgs/head/age.png'),
      navList: [
        { name: '官网首页', url: '/' },
        { name: '快速注册', url: 'Register' },
        { name: '下载中心', url: 'DownLoad' },
        { name: 'logo', url: '', type: 'logo' },
        { name: '商城专区', url: publicUrl.shopHomeUrl },
        { name: '新闻中心', url: 'News' },
        { name: '充值中心', url: 'Recharge' },
        { name: '玩家互动', url: 'interaction' },
      ],
    }
  },
  created() {
    window.addEventListener('scroll', this.winScroll)
    this.navActive = this.navList.findIndex((item) => item.url == this.$route.name);
  },
  methods: {
    winScroll() {
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop > 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    navFn(item, ind) {   // 点击菜单
      // console.log(item, ind);

      if (item.name == 'logo') return
      else {
        this.navActive = ind
        if (item.name == '商城专区') {
          window.open(item.url, '_blank');    // 商城
        }
        else if (item.url == 'Recharge') {
          this.$router.push('/recharge')
        } else if (item.url == 'Register') {
          this.$router.push('/register')
        } else if (item.url == 'DownLoad') {
          this.$router.push('/downLoad')
        } else if (item.url == 'interaction') {
          window.open('https://tieba.baidu.com/f?ie=utf-8&kw=%E5%AE%A0%E7%89%A9%E6%A3%AE%E6%9E%97&fr=search')
        }
        else {
          document.documentElement.scrollTop = 0
          this.$router.push(item.url)
          this.navActive = ind
        }
      }

    },
  },
}
</script>
<style scoped lang="less">
.headerWrap {
  margin-bottom: 10px;
  // position: sticky;
  position: relative;
  top: 70px;
  z-index: 999;

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    color: rgb(255, 255, 255);
    // color: #fff;
    // background: rgba(116, 81, 255, 0.8);
    // background: #FFFFFF80;
    background-image: url(../../assets/imgs/head/head_bg.png);
    background-position: center;
    background-repeat: no-repeat;
    // background-size: auto 100%;


    .age {
      img {
        height: 40px;
      }
    }

    .navWrap {
      display: flex;
      flex-direction: row;
      align-items: center;

      .navLi {
        span {
          margin: 0 10px;
          display: inline-block;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          cursor: pointer;
        }

      }

      .active {
        border-bottom: 4px solid #ffffff;
      }
    }
  }

  .headerScr {
    // background: rgba(116, 81, 255, 1);
    // background: #FFFFFF80;

  }
}
</style>
